<div class="card container d-flex fd-col" ngClass="height-desktop">
  <suvo-bi-limited-data-banner
    class="restrictions-banner"
    [isTrial]="isTrialing"
    [featureShortCode]="'FINDANDPAGINATE'"
    [tags]="[tileInstance.recipe?.dataSource]"
    *ngIf="hasRestrictions"
  ></suvo-bi-limited-data-banner>
  <ng-container *ngIf="!loading; else skeleton">
    <google-map [options]="mapOptions" height="100%" width="100%">
      <deprecated-map-marker-clusterer
        *ngIf="!printView"
        [imagePath]="clusterImage"
        (clusterClick)="onClusterClick($event)"
      >
        <map-marker
          *ngFor="let marker of markers"
          [title]="marker.title"
          [position]="marker.position"
          (mapClick)="onMarkerClick(marker)"
        ></map-marker>
      </deprecated-map-marker-clusterer>
    </google-map>
  </ng-container>

  <ng-template #skeleton>
    <div class="row-padding flex-1 d-flex fd-col ai-stretch">
      <suvo-bi-skeleton-map class="flex-1"></suvo-bi-skeleton-map>
    </div>
  </ng-template>
</div>
